<div class="container-fluid">
  <form [formGroup]="form1">
    <div class="row wrap m-0">
      <div class="col-lg-12 col-md-6">
        <mat-card>
          <mat-card-header>
            <mat-card-title>Vacancy Report</mat-card-title>
          </mat-card-header>
          <mat-card-content class="d-flex">
            <app-search-template
              searchLabel="Search"
              [showSearchButton]=true
              [reset]=true
              [showLocations]=true
              [showDevelopments]=true
              [showShortTermRentals]=true
              [showRateBuckets]=true
              [showBedrooms]=true
              [showSeasons]=true
              [showStartDate]=true
              [showEndDate]=true
              [startDate]="currentDate"
              [endDate]="currentDate"
              (doSearchCB)="onSearchSubmit($event)"
              [displayRecordsOnPageLoad]="true">
            </app-search-template>
            <app-import-export [importDisabled]="true" [tagsourceForInput]="50" [dataRetrived]="reports"
            (exportDataSelected)="exportSelected($event)" [sampleFileLink]="sampleLink" [columns]="columns"></app-import-export>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </form>
  <div class="row m-0">
    <div class="col-sm-12">
      <p-table #pt
        [value]="reports"
        [paginator]="true" [columns]="columns"
        [rows]="100"
        [rowsPerPageOptions]="[100,200,300,500]"
        [responsive]="true"
        sortMode="multiple"
        selectionMode="single"
        [(selection)]="report"
        dataKey="reportId"
        (onRowSelect)="onRowSelect($event)"
        [loading]="loading">
        <ng-template pTemplate="header" class="w-100">
          <tr>
            @for (col of columns; track col) {
              <th [pSortableColumn]="col.field">
                {{col.header}}
                <p-sortIcon [field]="col.field"></p-sortIcon>
              </th>
            }
          </tr>
          <tr>
            @for (col of columns; track col) {
              <th>
                @switch (col.field) {
                  @case ('locationName') {
                    <input pInputText type="text" (input)="pt.filter($event.target.value, col.field, col.filterMatchMode)">
                  }
                  @case ('developmentName') {
                    <input pInputText type="text" (input)="pt.filter($event.target.value, col.field, col.filterMatchMode)">
                  }
                  @case ('buildingName') {
                    <input pInputText type="text" (input)="pt.filter($event.target.value, col.field, col.filterMatchMode)">
                  }
                  @case ('propertyCode') {
                    <input pInputText type="text" (input)="pt.filter($event.target.value, col.field, col.filterMatchMode)">
                  }
                  @case ('vacancyDate') {
                    <input pInputText type="text" (input)="pt.filter($event.target.value, col.field, col.filterMatchMode)">
                  }
                  @case ('vacancyDay') {
                    <input pInputText type="text" (input)="pt.filter($event.target.value, col.field, col.filterMatchMode)">
                  }
                  @case ('vacancyTime') {
                    <input pInputText type="text" (input)="pt.filter($event.target.value, col.field, col.filterMatchMode)">
                  }
                }
              </th>
            }
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns">
          <tr>
            @for (col of columns; track col) {
              <td>
                {{rowData[col.field]}}
              </td>
            }
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>